import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormDatePicker from "../../components/formFields/FormDateField";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../../app/store";
import { LoadingPanel } from "../../components/layout/Loading";
import moment from "moment";
import {
  getKarigarListByProcess,
  getKarigarStock,
} from "../karigar/services/karigar.services";

import { findAllActiveItem } from "../item/services/item.services";
import { findAllActivePurity } from "../purity/services/purity.services";
import { findAllActiveProcess } from "../process/services/process.services";
import JadaiReceiptOrderItemEntryArray from "./JadaiReceiptOrderItemEntryArray";
import { findAllActiveUnit } from "../unit/services/unit.services";
import { findAllActiveItemCategory } from "../itemcategory/services/itemcategory.services";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { clearJadaiReceiptDetail } from "./jadaiReceiptSlice";
import {
  createJadaiReceipt,
  getJadaiReceiptById,
  updateJadaiReceipt,
} from "./services/jadaireceipt.services";
import JadaiReceiptOrderListArray from "./JadaiReceiptOrderListArray";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import { clearKarigarStock } from "../karigar/karigarSlice";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { FaEye } from "react-icons/fa";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const JadaiOrderEntryChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const jadai_receipt_order = formRenderProps.valueGetter(
    "jadai_receipt_order",
  );

  const karigar_id = formRenderProps.valueGetter("karigar_id");
  const KarigarList = useAppSelector((state) => state.karigar?.KarigarList);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const JadaiReceiptOrderItemIndex = useAppSelector(
    (state) => state.jadaireceipt.JadaiReceiptOrderItemIndex,
  );

  const currentIndex =
    JadaiReceiptOrderItemIndex === 999
      ? jadai_receipt_order?.length === 0
        ? 0
        : jadai_receipt_order?.length - 1
      : JadaiReceiptOrderItemIndex;

  const dispatch = useAppDispatch();

  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };
  useEffect(() => {
    if (karigar_id) {
      fetchKarigarStock(karigar_id);
    }
  }, [karigar_id]);

  useEffect(() => {
    if (karigar_id && KarigarList && KarigarList?.length > 0) {
      const selectedKarigar = KarigarList.find(
        (karigar) => karigar.karigar_id === karigar_id,
      );
      if (selectedKarigar) {
        const wastage = selectedKarigar?.wastage;
        formRenderProps.onChange(`karigar_wastage`, {
          value: wastage || 0,
        });
      }
    }
  }, [karigar_id, KarigarList]);

  useEffect(() => {
    if (jadai_receipt_order && jadai_receipt_order?.length > 0) {
      jadai_receipt_order?.forEach((receipt_order: any, index: number) => {
        console.log(receipt_order);
        if (!receipt_order.order_no) return;
        const netWeight =
          (receipt_order.gross_weight || 0) - (receipt_order.stone_weight || 0);
        const phine =
          netWeight * ((receipt_order.purity + receipt_order.wastage) / 100);
        const less_weight =
          netWeight -
          (receipt_order.weight || 0) -
          (receipt_order.kundan ? (receipt_order.kundan / 91.7) * 100 : 0);
        const opensetting = receipt_order.ForOpenSettings;

        if (
          dialogName === "jadai-receipt-order-entry-dialog" &&
          index === currentIndex
        ) {
          if (!opensetting) {
            formRenderProps.onChange(
              `jadai_receipt_order.${index}.less_jadai_verification`,
              {
                value:
                  (receipt_order?.with_without_variation
                    ? (less_weight / 100) * 80
                    : less_weight) || receipt_order.less_jadai_verification,
              },
            );
          } else {
            formRenderProps.onChange(
              `jadai_receipt_order.${index}.less_jadai_verification`,
              {
                value:
                  receipt_order.net_weight -
                  (receipt_order.weight +
                    (receipt_order.kundan
                      ? (receipt_order.kundan / 91.7) * 100
                      : 0) +
                    receipt_order.stone_qty * 0.015),
              },
            );
          }
        }
        formRenderProps.onChange(`jadai_receipt_order.${index}.net_weight`, {
          value: netWeight,
        });
        formRenderProps.onChange(`jadai_receipt_order.${index}.phine`, {
          value: phine.toFixed(3),
        });
      });
    }
  }, [
    jadai_receipt_order?.map((item: any) => item.gross_weight).join("-"),
    jadai_receipt_order?.map((item: any) => item.stone_weight).join("-"),
    jadai_receipt_order?.map((item: any) => item.purity).join("-"),
    jadai_receipt_order?.map((item: any) => item.wastage).join("-"),
    jadai_receipt_order?.map((item: any) => item.weight).join("-"),
    jadai_receipt_order?.map((item: any) => item.kundan).join("-"),
    jadai_receipt_order?.map((item: any) => item.ForOpenSettings).join("-"),
    dialogName,
  ]);

  return null;
};

const CreateJadaiReceipt: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);

  const jadai_receipt_guid = location?.state?.jadai_receipt_guid;
  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );
  const loading = useAppSelector((state) => state.jadaireceipt.loading);
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);

  const JadaiReceiptDetail = useAppSelector(
    (state: RootState) => state.jadaireceipt.JadaiReceiptDetail,
  );
  const JadaiReceiptOrderSave = useAppSelector(
    (state: RootState) => state.jadaireceipt.JadaiReceiptOrderSave,
  );

  const [formKey, setFormKey] = useState(1);

  const today = new Date();
  const maxDate =
    new Date(today.getFullYear(), today.getMonth(), today.getDate()) || null;

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [JadaiReceiptDetail]);

  const handleFormClose = () => {
    navigate("/jadaireceipt");
  };

  useEffect(() => {
    dispatch(findAllActiveProcess());
    dispatch(getKarigarListByProcess(PROCESS_ID.jadai));
    dispatch(findAllActivePurity());
    dispatch(findAllActiveItem());
    dispatch(findAllActiveUnit());
    dispatch(findAllActiveItemCategory());
    return () => {
      dispatch(clearJadaiReceiptDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    if (jadai_receipt_guid) {
      dispatch(getJadaiReceiptById(jadai_receipt_guid));
    }
  }, [jadai_receipt_guid]);

  const handleSubmit = async (values: any) => {
    if (JadaiReceiptOrderSave) return false;
    const formdata = {
      karigar_id: values.karigar_id ? +values.karigar_id : null,
      receipt_date: values.receipt_date
        ? moment(values.receipt_date).format("YYYY-MM-DD")
        : "",
      jadai_receipt_order: values.jadai_receipt_order
        ? values.jadai_receipt_order?.map((jadai_order_item: any) => ({
            id: jadai_order_item.id ? jadai_order_item.id : 0,
            jadai_issue_id: jadai_order_item.jadai_issue_id ?? 0,
            order_id: jadai_order_item.order_id,
            item_id: jadai_order_item.item_id,
            item_category_id: jadai_order_item.item_category_id,
            item_description: jadai_order_item.item_description,
            weight: jadai_order_item.weight,
            gross_weight: jadai_order_item.gross_weight
              ? jadai_order_item.gross_weight
              : 0,
            stone_weight: jadai_order_item.stone_weight
              ? jadai_order_item.stone_weight
              : 0,
            net_weight: jadai_order_item.net_weight
              ? jadai_order_item.net_weight
              : 0,
            stone_qty: jadai_order_item.stone_qty
              ? jadai_order_item.stone_qty
              : 0,
            rate: jadai_order_item.rate ? jadai_order_item.rate : 0,
            extra_cost: jadai_order_item.extra_cost
              ? jadai_order_item.extra_cost
              : 0,
            total: jadai_order_item.total ? jadai_order_item.total : 0,
            purity: jadai_order_item.purity ? jadai_order_item.purity : 0,
            wastage: jadai_order_item.wastage ? jadai_order_item.wastage : 0,
            kundan: jadai_order_item.kundan ? jadai_order_item.kundan : 0,
            phine: jadai_order_item.phine ? jadai_order_item.phine : 0,
            less_jadai_verification: jadai_order_item.less_jadai_verification,
            ForOpenSettings: jadai_order_item.ForOpenSettings === true,
            Dank: jadai_order_item.Dank || 0,
            iscaret: jadai_order_item.iscaret,
            isdesign: jadai_order_item.isdesign,
            isgoldcolor: jadai_order_item.isgoldcolor,
            isweight: jadai_order_item.isweight,
            issize: jadai_order_item.issize,
            ispolishcolor: jadai_order_item.ispolishcolor,
            isfinishorder: jadai_order_item.isfinishorder,
            iseverythingasdescription:
              jadai_order_item.iseverythingasdescription,
            approval_items: [],
            item_used_by_kariagr: jadai_order_item.item_used_by_kariagr
              ? jadai_order_item.item_used_by_kariagr
                  ?.filter(
                    (item: any) =>
                      item?.item_id &&
                      item?.weight &&
                      item?.qty &&
                      item?.apply_on &&
                      item?.unit_id &&
                      item?.rate,
                  )
                  ?.map((karigar: any) => ({
                    id: karigar?.id ? karigar?.id : 0,
                    item_id: karigar?.item_id,
                    weight: karigar?.weight,
                    qty: karigar?.qty,
                    apply_on: karigar?.apply_on,
                    unit_id: karigar?.unit_id,
                    rate: karigar?.rate,
                    total: karigar?.total,
                    custom_rate: karigar?.custom_rate,
                    customer_less_weight: karigar?.customer_less_weight,
                  }))
              : [],
          }))
        : [],
    };

    if (jadai_receipt_guid) {
      const editPayload = {
        ...formdata,
        jadai_receipt_guid: jadai_receipt_guid,
      };
      try {
        const response = await dispatch(updateJadaiReceipt(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (jadai_receipt_guid) {
            dispatch(getJadaiReceiptById(jadai_receipt_guid));
          }
          navigate("/jadaireceipt/edit", {
            state: {
              jadai_receipt_guid: jadai_receipt_guid,
            },
          });
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createJadaiReceipt(formdata));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/jadaireceipt/edit", {
            state: {
              jadai_receipt_guid: response.payload.jadai_receipt_guid,
            },
          });
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={JadaiReceiptDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <JadaiOrderEntryChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "33%" }, { width: "33%" }, { width: "33%" }]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {jadai_receipt_guid
                      ? "Update Jadai Receipt"
                      : "Create Jadai Receipt"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.jadai}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="receipt_date"
                    label="Receipt Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    max={maxDate}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <div className="stock-container">
                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Amount Balance
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                      >
                        {formatToIndianCurrencyWithoutSymbol(
                          karigarStock.amount || 0,
                        )}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.Amount_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>

                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Phine (gm) Stock
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                      >
                        {formatWeight(karigarStock.phine)}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.phine_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10, padding: 12 }}>
              {/* THIS IS FOR LISTING */}
              <FieldArray
                formRenderProps={formRenderProps}
                component={JadaiReceiptOrderListArray}
                name="jadai_receipt_order"
              />
              {/* THIS IS FOR DIALOG */}
              <FieldArray
                formRenderProps={formRenderProps}
                component={JadaiReceiptOrderItemEntryArray}
                name="jadai_receipt_order"
              />
              <GridLayoutItem
                colSpan={3}
                style={{
                  textAlign: "end",
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                {isPrintAccess && jadai_receipt_guid && (
                  <Button
                    type="button"
                    style={{ marginRight: 4 }}
                    fillMode={"solid"}
                    themeColor={"primary"}
                    onClick={() =>
                      window.open(
                        `/jadaireceipt/${jadai_receipt_guid}`,
                        "_blank",
                      )
                    }
                  >
                    <FaEye style={{ fontSize: "18" }} /> View Report
                  </Button>
                )}
                <ButtonWithLoading
                  type="submit"
                  label={!jadai_receipt_guid ? "Create" : "Update"}
                  themeColor={"primary"}
                  fillMode={"solid"}
                  disabled={!formRenderProps.allowSubmit || loading}
                  loading={loading}
                />
                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 4 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateJadaiReceipt;
